import React from 'react';
import { createUseStyles, useTheme } from 'react-jss';
import { Theme } from '@app/theme';

const mutedColors: { [key: string]: keyof Theme['colors'] } = {
  red: 'redMuted',
  blue: 'blueMuted',
  green: 'greenMuted',
};

const useStyles = createUseStyles((theme: Theme) => ({
  container: {
    display: 'flex',
    height: '100vh',
  },
  panel: {
    background: ({ color }: Props) => theme.colors[mutedColors[color]],
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.marginBase * 8,
    '& > h1': {
      ...theme.fonts.h1,
      fontSize: 46,
      '& > strong': {
        ...theme.fonts.h1,
        fontSize: 46,
        color: ({ color }: Props) => theme.colors[color],
      },
    },
    [theme.media.tablet]: {
      display: 'none',
    },
  },
  formPane: {
    width: '100vw',
    maxWidth: theme.maxContentWidth.reducedFormContent + theme.marginBase * 20, // + padding
    position: 'relative',
    [theme.media.tablet]: {
      margin: 'auto',
      maxWidth: theme.maxContentWidth.reduced,
    },
  },
  absoluteFormBox: {
    ...theme.absoluteFill,
    overflow: 'auto',
    display: 'flex',
    flexDirection: 'column',
    [theme.media.tablet]: {
      position: 'relative',
    },
  },
  centerBox: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: `${theme.marginBase * 7}px ${theme.marginBase * 10}px`,
    [theme.media.tablet]: {
      padding: `${theme.marginBase * 4}px ${theme.marginBase * 2}px`,
    },
  },
}));

interface Props {
  children: React.ReactNode;
  panelContent: React.ReactNode;
  color: 'red' | 'green' | 'blue';
}

export const LargePanePage = (props: Props) => {
  const theme: Theme = useTheme();
  const classes = useStyles({ ...props, theme });

  return (
    <div className={classes.container}>
      <div className={classes.panel}>{props.panelContent}</div>
      <div className={classes.formPane}>
        <div className={classes.absoluteFormBox}>
          <div className={classes.centerBox}>{props.children}</div>
        </div>
      </div>
    </div>
  );
};
